import React, { useState } from 'react';
import FeedbackService from 'service/FeedbackService';
import { useTheme } from 'contexts/ThemeContext';

const FeedbackPage = () => {
    const { theme } = useTheme();
    const [formData, setFormData] = useState({
        name: '',
        contact_info: '',
        message_type: 'proposal',
        message: ''
    });
    const [status, setStatus] = useState('idle'); // idle, submitting, success, error

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('submitting');
        try {
            await FeedbackService.createFeedback(formData);
            setStatus('success');
            setFormData({ name: '', contact_info: '', message_type: 'proposal', message: '' });
        } catch (error) {
            console.error(error);
            setStatus('error');
        }
    };

    const isDark = theme === 'dark';

    return (
        <div style={{
          
            padding: '40px 20px 40px',
            color: isDark ? '#fff' : '#1a1a1a',
          
            fontFamily: "'Inter', sans-serif"
        }}>
            <div style={{ textAlign: 'left', marginBottom: '60px' }}>
                <h1 style={{ 
                    fontSize: '42px', 
                    fontWeight: '800', 
                    marginBottom: '20px',
                    background: isDark ? 'linear-gradient(135deg, #fff 0%, #a5a5a5 100%)' : 'linear-gradient(135deg, #1a1a1a 0%, #4a4a4a 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                }}>
                    Мы Вас слышим
                </h1>
                <p style={{ 
                    fontSize: '18px', 
                    lineHeight: '1.6', 
                    opacity: 0.8, 
                 
                    
                }}>
                    Ваше мнение — топливо для нашего роста. Мы ценим каждую идею, замечание или предложение. 
                    Расскажите, что можно улучшить, и мы сделаем это.
                </p>
            </div>

            <div style={{
                background: isDark ? 'rgba(30, 30, 40, 0.6)' : 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(20px)',
                borderRadius: '30px',
                padding: '40px',
                border: isDark ? '1px solid rgba(255, 255, 255, 0.05)' : '1px solid rgba(0, 0, 0, 0.05)',
                boxShadow: isDark ? '0 20px 50px rgba(0,0,0,0.3)' : '0 20px 50px rgba(0,0,0,0.05)'
            }}>
                {status === 'success' ? (
                    <div style={{ textAlign: 'center', padding: '40px 0' }}>
                        <div style={{ fontSize: '60px', marginBottom: '20px' }}>✨</div>
                        <h3 style={{ fontSize: '24px', marginBottom: '10px' }}>Спасибо за отклик!</h3>
                        <p style={{ opacity: 0.7 }}>Мы уже получили ваше сообщение и внимательно его изучим.</p>
                        <button 
                            onClick={() => setStatus('idle')}
                            style={{
                                marginTop: '30px',
                                background: 'transparent',
                                border: `1px solid ${isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)'}`,
                                color: 'inherit',
                                padding: '10px 24px',
                                borderRadius: '12px',
                                cursor: 'pointer'
                            }}
                        >
                            Отправить еще
                        </button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <label style={{ fontSize: '14px', fontWeight: '600', opacity: 0.7 }}>Ваше имя</label>
                                <input 
                                    type="text" 
                                    name="name"
                                    required
                                    value={formData.name}
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '14px',
                                        background: isDark ? 'rgba(255,255,255,0.05)' : '#f5f5f5',
                                        border: 'none',
                                        borderRadius: '12px',
                                        color: 'inherit',
                                        outline: 'none',
                                        fontSize: '16px'
                                    }}
                                    placeholder="Как к вам обращаться?"
                                />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <label style={{ fontSize: '14px', fontWeight: '600', opacity: 0.7 }}>Контакты</label>
                                <input 
                                    type="text" 
                                    name="contact_info"
                                    required
                                    value={formData.contact_info}
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '14px',
                                        background: isDark ? 'rgba(255,255,255,0.05)' : '#f5f5f5',
                                        border: 'none',
                                        borderRadius: '12px',
                                        color: 'inherit',
                                        outline: 'none',
                                        fontSize: '16px'
                                    }}
                                    placeholder="Email или телефон"
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <label style={{ fontSize: '14px', fontWeight: '600', opacity: 0.7 }}>Тема обращения</label>
                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                {[
                                    { val: 'proposal', label: '💡 Предложение' },
                                    { val: 'complaint', label: '⚠️ Жалоба' },
                                    { val: 'partnership', label: '🤝 Партнерство' },
                                    { val: 'callback', label: '📞 Обратный звонок' },
                                    { val: 'other', label: '💬 Другое' }
                                ].map(type => (
                                    <div 
                                        key={type.val}
                                        onClick={() => setFormData({...formData, message_type: type.val})}
                                        style={{
                                            padding: '10px 16px',
                                            borderRadius: '10px',
                                            background: formData.message_type === type.val 
                                                ? (isDark ? '#fff' : '#000') 
                                                : (isDark ? 'rgba(255,255,255,0.05)' : '#f5f5f5'),
                                            color: formData.message_type === type.val 
                                                ? (isDark ? '#000' : '#fff') 
                                                : 'inherit',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            transition: 'all 0.2s'
                                        }}
                                    >
                                        {type.label}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <label style={{ fontSize: '14px', fontWeight: '600', opacity: 0.7 }}>Сообщение</label>
                            <textarea 
                                name="message"
                                required
                                value={formData.message}
                                onChange={handleChange}
                                style={{
                                    width: '100%',
                                    minHeight: '150px',
                                    padding: '14px',
                                    background: isDark ? 'rgba(255,255,255,0.05)' : '#f5f5f5',
                                    border: 'none',
                                    borderRadius: '12px',
                                    color: 'inherit',
                                    outline: 'none',
                                    fontSize: '16px',
                                    resize: 'vertical'
                                }}
                                placeholder="Расскажите подробнее..."
                            />
                        </div>

                        <button 
                            type="submit"
                            disabled={status === 'submitting'}
                            style={{
                                marginTop: '10px',
                                padding: '16px',
                                borderRadius: '14px',
                                background: isDark ? 'linear-gradient(90deg, #7000ff, #a033ff)' : '#1a1a1a',
                                color: '#fff',
                                border: 'none',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                opacity: status === 'submitting' ? 0.7 : 1,
                                transition: 'transform 0.1s'
                            }}
                            onMouseDown={e => e.target.style.transform = 'scale(0.98)'}
                            onMouseUp={e => e.target.style.transform = 'scale(1)'}
                        >
                            {status === 'submitting' ? 'Отправка...' : 'Отправить сообщение'}
                        </button>

                        {status === 'error' && (
                            <p style={{ color: '#ff4444', textAlign: 'center' }}>
                                Произошла ошибка. Попробуйте позже.
                            </p>
                        )}
                    </form>
                )}
            </div>
        </div>
    );
};

export default FeedbackPage;
